import React, {useEffect} from "react"
import ReactGA from "react-ga"
import SEO from "../../components/seo"
import { Link } from "gatsby"
import track from "../../components/track"
import valinorLogo from "../../images/averitas-logo.png"
import movantikLogo from "../../images/movantik-logo.png"
import savingsCard from "../../images/savings-card-print.png"
import "../../components/layout.css"

// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== "undefined"

const isNotMobileGroupId = "99996001";
const isMobileGroupId = "99996001";


if (isBrowser) {
  window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
}

const SavingsPrint = () => {

  const pageTitle="Savings";
  const pageDescription = "Save on your MOVANTIK prescription today with the Savings Card and more. Get help treating opioid-induced constipation.";
  const pageName = "Savings Print";

  // Google analytics
  if (typeof window !== "undefined") {
    var host = window.location.hostname
    var GACode = "UA-155993142-4"
    if (host.includes("localhost") || host.includes("bgbdigital")) {
      GACode = "UA-45051197-16"
    }
    ReactGA.initialize(GACode)
    ReactGA.pageview(window.location.pathname + window.location.search)
  }

  var data, response, cardNumberLocation, groupNumberLocation;

  
    

  function getCardNumber(){

    var cors_api_url = "https://phpstack-1015649-5875846.cloudwaysapps.com/cors/generate_card_number.php";

  
fetch(cors_api_url)
  .then(response => response.text())
  .then(data => {
    let parser = new DOMParser();
    let xml = parser.parseFromString(data, "text/html");
    let json = xml.firstChild.textContent;
    let array_data = JSON.parse(json);
    let cardNumber = array_data['memberid'];
    cardNumberLocation = document.getElementById('card-id');
    cardNumberLocation.textContent = cardNumber;

    groupNumberLocation = document.getElementById('group-id');
    if (isBrowser) {
      groupNumberLocation.textContent = window.mobileCheck() ? isMobileGroupId : isNotMobileGroupId;
    }
  });
	}

  useEffect(() => {
    getCardNumber();

    // add google tag manager script
    const gtmScript = document.createElement('script');
    gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=DC-10089119";
    document.body.appendChild(gtmScript);

    // add global floodlight tags script
    const floodlightScript = document.createElement('script');
    floodlightScript.src = "/floodlight-global.js";
    document.body.appendChild(floodlightScript);

    // pulse tracking
    if (typeof window !== "undefined") {
      var urlHost = window.location.hostname
      var pulseIdScriptContent, pulseNoscriptContent;
      const pulseIdScript = document.createElement('script');
      pulseIdScript.type = 'text/javascript';
      const pulseScript = document.createElement('script');
      pulseScript.type = 'text/javascript';
      const pulseNoscriptNode = document.createElement('noscript');
      if (urlHost.includes('staging')){
        pulseIdScriptContent = 'var pulseSiteID = 24';
        pulseScript.src = '//tracking-beta.explorepulse.com/track.js';
        pulseNoscriptContent = '<p><img src="//tracking-beta.explorepulse.com/track-noscript.php?idsite=24&rec=1" style="border:0;" alt="" /></p>'
      } else {
        pulseIdScriptContent = 'var pulseSiteID = 29';
        pulseScript.src = '//tracking.explorepulse.com/track.js';
        pulseNoscriptContent = '<p><img src="//tracking.explorepulse.com/track-noscript.php?idsite=29&rec=1" style="border:0;" alt="" /></p>';
      }
      pulseIdScript.innerHTML = pulseIdScriptContent;
      document.head.appendChild(pulseIdScript);
      document.head.appendChild(pulseScript);
      pulseNoscriptNode.innerHTML = pulseNoscriptContent;
      document.body.appendChild(pulseNoscriptNode);
    }

    // track when a page has been open for 30+ seconds
    let pageLoadTimeout = setTimeout(function(){
      track('patient ' + pageName + ' page', 'Time Spent', 'DTC Global - Time Spent 30s+');
      track('Global', 'Time Spent', 'DTC Global - Time Spent 30s+ v2');
    },30000);

    return () => {
      clearTimeout(pageLoadTimeout);
    }
  }, [])

  return (
    <>
      <SEO title={pageTitle} description={pageDescription} />
      <div className="savings-print">
        <div className="reg-complete">Registration complete.</div>
        <div className="return">
          Return to <Link to="/savings/" id="patient-savingsprint-link-return"><span className="orange" onClick={() => track("patient Savings Print page", "link click", "DTC Savings Print-Return to Savings")}>[movantik.com]</span></Link>
        </div>
        <div className="center print-header">Print this page or pull it up on your mobile device at the pharmacy!</div>

        <div className="container">
          <div className="columns two">

            <div className="column left-column">
              <div className="border-column">
              <div className="savings-card-callout">
                  <img src={movantikLogo} alt="Movantik" className="movantik-logo" />
                  <div className="savings-card-callout-headline">If eligible, you may SAVE* on your&nbsp;prescription.<br />Present this Savings Card to your pharmacist.</div>
                  <div className="savings-card-img-container">
                    <img src={savingsCard} alt="Savings Card" className="savings-card-img" />
                    <div className="card-numbers">
                      <p>BIN: <span className="card-number">017290</span></p>
                      <p>PCN: <span className="card-number">ACR</span></p>
                      <p>GRP: <span id="group-id" className="card-number"></span></p>
                      <p>ID: <span id="card-id" className="card-number"></span></p>
                    </div>
                  </div>
                </div>
                <h1>After your doctor prescribes MOVANTIK:</h1>
                <div className="resource-item">
                  <div className="resource-main">
                    <div className="resource-number">1</div>
                    <div className="resource-content">
                      <p>You may print a Savings Card or pull up the Savings Card on your mobile device</p>
                    </div>
                  </div>
                </div>
                <div className="resource-item">
                  <div className="resource-main">
                    <div className="resource-number">2</div>
                    <div className="resource-content">
                      <p>Your pharmacist can assist with confirming eligibility</p>
                    </div>
                  </div>
                </div>
                {/* <div className="resource-item">
                  <div className="resource-main">
                    <div className="resource-number">3</div>
                    <div className="resource-content">
                      <p>Bring prescription and Savings Card to your pharmacy</p>
                    </div>
                  </div>
                </div> */}
                
                
              </div>
              <div className="end-matter">
                <div className="footnote">*Subject to complete eligibility rules; restrictions apply. See below for eligibility information and instructions. If eligible, show your card and prescription to your pharmacist for instant savings.</div>
              </div>
            </div>

            <div className="column right-column">
              <div className="end-matter">

                <div className="rules">
                  <div className="rule-section">
                    <p><span className="bold">PATIENT INSTRUCTIONS:</span> Present this offer to your pharmacist along with a valid prescription for MOVANTIK<sup>&reg;</sup> (naloxegol) Tablets. Please call <a href="tel:3128960135">312-896-0135</a> with questions and for full eligibility details.</p>
                    <p><span className="bold">TERMS AND CONDITIONS:</span> Offer good for patients who meet eligibility criteria purchasing a 30-, 60-, or 90-day supply. Eligible commercially insured patients will pay as little as <span className="bold">$0 for their monthly prescription,</span> subject to a maximum benefit limit. Eligible uninsured (cash-paying) patients will receive savings on eligible out-of-pocket costs subject to a maximum benefit limit.</p>
                    <p>This program provides eligible patients with assistance to reduce out-of-pocket costs. By using this offer, patient and pharmacist understand and agree to comply with these terms and conditions. Only eligible U.S. residents may use this offer at participating pharmacies and may not redeem this offer at government-subsidized clinics. Offer user must be at least 18 years of age to use for themselves or on behalf of a minor. Patient age or insurance restrictions may apply.</p>
                    <p><span className="bold">Restrictions:</span> No substitutions are permitted. Offer eligible only with valid prescription, has no cash value, and cannot be combined with any free trial, discount, prescription savings card, or other offer. This offer is not insurance. Valid only for patients with commercial insurance. This offer is NOT valid for prescriptions eligible to be reimbursed in whole or in part by Medicaid, Medicare (including Medicare Advantage and Part D plans), Veterans Affairs (VA), Department of Defense (DOD) programs or TriCare, or any other federally or state funded healthcare benefit program, or by commercial plans or health or pharmacy benefit programs that reimburse for the entire cost of the prescription drug or prohibit offer’s use. Medicare Part D enrollees who are in the prescription drug coverage gap are not eligible for offer. <span className="bold">This offer is not transferable and is limited to one offer per person.</span> Void were prohibited by law, taxed, or restricted. It is illegal to sell, purchase, trade, or counterfeit, or offer to sell, purchase, trade, or counterfeit the offer.</p>
                    <p>Averitas Pharma, Inc., reserves the right to rescind, revoke, or amend the offer at any time without notice.</p>
                    <p><span className="bold">Pharmacist instruction for a patient with an eligible Third-Party Payer:</span> Submit the claim to the primary Third-Party Payer first, then submit the balance due as a Secondary Payer using Secondary Payer COB [coordination of benefits] with patient responsibility amount and a valid Other Coverage Code (eg, 8 or 3).</p>
                    <p><span className="bold">Pharmacist instruction for a cash-paying patient:</span> Submit this claim as a Primary Payer using a valid Other Coverage Code (eg, 1).</p>
                    <p><em>For any questions regarding online processing, call the Pharmacy Help Desk at <a href="tel:3128960135">312-896-0135</a>.</em></p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <footer>
            <img src={valinorLogo} alt="Valinor Pharma, LLC" className="footer-logo" />
            <span className="footer-text end-matter">MOVANTIK is a registered trademark of Averitas Pharma, Inc.<br/>&copy; 2026 Averitas Pharma, Inc.</span>
          </footer>

        </div>
      </div>
    </>
  )
}

export default SavingsPrint
